module.exports = __webpack_public_path__ + "static/img/home-new1.af8b7949.jpg";